import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, Radio, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { TTitulosPossiveisSafraEdi } from "../../../../../../../types/api/financeiro/detalhar-integracao-bancaria";
import { useRef, useState } from "react";
import moment from "moment";
import { formatarValorMonetario } from "../../../../../../../helpers/masks";
import DisplayNotFoundInfo from "../../../../../../../components/DisplayNotFindInfo";
import ClearIcon from "@mui/icons-material/Clear";
import PaperDraggable from "../../../../../../../components/PaperDraggable";

export default function SelectIndicarTituloSafra({
    onChange,
    onLimpar,
    value,
    opcoes
}: SelectIndicarTituloSafraProps) {

    const [openModal, setOpenModal] = useState<boolean>(false);

    return (
        <>
            <TextField
                fullWidth
                label={"Indicar título"}
                value={value ? value : ""}
                onClick={() => setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                slotProps={{
                    input: {
                        readOnly: true,
                        endAdornment: value && (
                            <InputAdornment position="end">
                                <ClearIcon
                                    onClick={() => onLimpar()}
                                    style={{
                                        cursor: 'pointer',
                                        color: '#888'
                                    }}
                                />
                            </InputAdornment>
                        )
                    }
                }}
            />

            {openModal && (
                <DialogSelectItems
                    {...{ opcoes }}
                    open={openModal}
                    defValue={value}
                    handleClose={() => setOpenModal(false)}
                    onSubmitValue={(selectedValue: string) => {
                        onChange(selectedValue);
                    }}
                />
            )}
        </>
    );
}

function DialogSelectItems({
    open,
    defValue,
    opcoes,
    handleClose,
    onSubmitValue,
}: DialogSelectItemsProps) {
    const [selected, setSelected] = useState<string | null>(defValue);
    const tableContainerRef = useRef<HTMLDivElement>(null);

    //funções manipuladoras
    const handleSubmit = () => {
        if (selected) {
            onSubmitValue(selected);
            handleClose();
        }
    };

    const handleResolvidoPorFora = () => {
        onSubmitValue("Resolvido por fora");
        handleClose();
    };
    //

    //valores importantes
    const bloquearConfirmar = !selected;
    //
    return (
        <>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll="body"
                PaperComponent={PaperDraggable}
                aria-labelledby="draggable-dialog-title"
                fullWidth
                maxWidth="lg"
            >
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">Selecionar título</DialogTitle>

                <DialogContent>
                    <Box py={1}>
                        <Typography variant="body2" color="textSecondary">
                            Selecione o título relacionado à transação. Caso não encontre, você pode selecionar "Resolvido por fora".
                        </Typography>
                        {
                            opcoes.length === 0 && (
                                <Typography>
                                    <DisplayNotFoundInfo label="Nenhum título encontrado" />
                                </Typography>
                            )
                        }
                        {opcoes.length > 0 && (
                            <TableContainer
                                ref={tableContainerRef}
                                sx={{ height: 400, overflow: "auto", mb: 1 }}
                            >
                                <Table size="small" aria-label="a dense table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>
                                                <b>Título</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Emissão</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Vencimento</b>
                                            </TableCell>
                                            <TableCell align="right">
                                                <b>Valor</b>
                                            </TableCell>
                                            <TableCell align="right">
                                                <b>Saldo</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Nsu</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Autorização</b>
                                            </TableCell>
                                            <TableCell>
                                                <b>Situação</b>
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {opcoes.map((row) => {
                                            const radioMarcado = selected === row.identificacao;

                                            return (
                                                <TableRow
                                                    key={row.identificacao}
                                                    sx={{
                                                        cursor: "pointer",
                                                        backgroundColor: radioMarcado ? "#edf7ed" : "unset",
                                                        "&:last-child td, &:last-child th": { border: 0 },
                                                    }}
                                                    onClick={() => {
                                                        setSelected(row.identificacao);
                                                    }}
                                                >
                                                    <TableCell>
                                                        <Radio
                                                            name="radio-buttons"
                                                            checked={radioMarcado}
                                                            slotProps={{ input: { "aria-label": row.identificacao } }}
                                                        />
                                                    </TableCell>
                                                    <TableCell>{row.identificacao}</TableCell>
                                                    <TableCell>
                                                        {moment(row.data_emissao).format("DD/MM/YYYY")}
                                                    </TableCell>
                                                    <TableCell>{moment(row.data_vencimento).format("DD/MM/YYYY")}</TableCell>
                                                    <TableCell align="right">{formatarValorMonetario(row.valor_receber)}</TableCell>
                                                    <TableCell align="right">{formatarValorMonetario(row.saldo_principal)}</TableCell>
                                                    <TableCell>{row.nsu_cartao}</TableCell>
                                                    <TableCell>{row.autorizacao_cartao}</TableCell>
                                                    <TableCell>{row.situacao}</TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose}>Cancelar</Button>
                    <Button
                        variant="outlined"
                        onClick={handleResolvidoPorFora}
                    >
                        Resolvido por fora
                    </Button>
                    <Button
                        autoFocus
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={bloquearConfirmar}
                    >
                        Selecionar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

interface SelectIndicarTituloSafraProps {
    onChange: (value: string) => void;
    onLimpar: () => void;
    value: string | null;
    opcoes: TTitulosPossiveisSafraEdi[];
}

interface DialogSelectItemsProps {
    open: boolean;
    opcoes: TTitulosPossiveisSafraEdi[];
    defValue: string | null;
    handleClose: () => void;
    onSubmitValue: (value: string) => void;
}
